export enum EnumQuoteStatus {
  DRAFT = "draft",
  OPEN = "open",
  ACCEPTED = "accepted",
  CANCELED = "canceled",
  EXPIRED = "expired",
}
